import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=7240994c&scoped=true&"
import script from "./ErrorMessage.vue?vue&type=script&lang=ts&"
export * from "./ErrorMessage.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorMessage.vue?vue&type=style&index=0&id=7240994c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7240994c",
  null
  
)

export default component.exports